import { Card, CardContent } from "@mui/material";
import { Component } from "./Component";
import { PropsWithChildren } from "react";

export function FixedComponent({
  config,
  children,
}: PropsWithChildren<{ config: Component }>) {
  return (
    <div
      style={{
        top: config.top + "px",
        left: config.left + "px",
        position: "absolute",
        cursor: "move",
        width: "fit-content",
      }}
    >
      <Card sx={{ minHeight: "40vh", minWidth: "10vw" }}>
        <CardContent>{children}</CardContent>
      </Card>
    </div>
  );
}
